/**
 * Парсит хеш с window.location и убирает # чтобы получуть роут
 */
export function routeFromHash(hash: string) {
  let result = hash;
  if (hash.indexOf('#') === 0) {
    result = hash.slice(1);
  }
  return result;
}
